import { useMemo, useState, type ReactNode } from "react";
import { PageHeaderContext, type PageHeaderMeta } from "@/layout/pageHeaderContext";

export function PageHeaderProvider({ children }: { children: ReactNode }) {
  const [meta, setMeta] = useState<PageHeaderMeta | null>(null);
  const value = useMemo(
    () => ({
      meta,
      setPageMeta: setMeta,
    }),
    [meta],
  );
  return <PageHeaderContext.Provider value={value}>{children}</PageHeaderContext.Provider>;
}
